import React from 'react'
import classNames from 'classnames'
import type { Props } from './types'
import Image from '@/components/image'
import styles from './style.module.scss'

const LocationModalContent: React.FC<Props> = ({
  title,
  text,
  image,
  caption,
}) => {
  const classes = classNames(styles['location-modal-content'])

  return (
    <div className={classes}>
      <div className={styles.left}>
        <span className={styles.title}>{title}</span>
        <span className={styles.text}>{text}</span>
      </div>
      <figure className={styles.right}>
        {image?.data && <Image data={image} />}
        {caption && <figcaption>{caption}</figcaption>}
      </figure>
    </div>
  )
}

export default React.memo(LocationModalContent)
